export const sendBackendPagination = (page: number) => {
    return page + 1;
}